module.exports = __webpack_public_path__ + "img/kk-1.80943311.png";